import { RootState } from "src/features/gifts/imports/types";

export const getAllCombos = (state: RootState) => state.giftsCombo;
export const getCombo = (state: RootState, giftId: string, accountId: string) =>
  state.giftsCombo[`${giftId}-${accountId}`];
